<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    :before-close="closeModal">

    
    <template v-if="modal.mode == 'Request Submission'">
      <!-- You are about to request the submission of the following payouts: -->
      <br><br>
      <ul>
        <li>Total pending payouts: {{ nbToRequest }}</li>
        <template v-if="nbExcluded > 0 || nbUnsubmittable > 0">
          <li v-if="nbExcluded > 0">Payouts manually excluded: {{ nbExcluded }}</li>
          <li v-if="nbUnsubmittable > 0">Payouts to affiliates with no card: {{ nbUnsubmittable }}</li>
          <li><b>Payouts to request submission for:</b> {{ nbToRequest - nbExcluded - nbUnsubmittable }}</li>
        </template>
      </ul>

      <span slot="footer" class="dialog-footer">
        <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
        <button class="btn btn-success" @click="submit()" :disabled="disableSubmitButton">Confirm</button>
      </span>
    </template>


    <template v-else-if="modal.mode == 'Submit'">
      <!-- The following payouts will be submitted for payment: -->
      <br><br>
      <ul>
        <li>Payouts to Submit: {{ nbToSubmit }}</li>
        <template v-if="nbExcluded">
          <li v-if="nbExcluded > 0">Payouts manually excluded: {{ nbExcluded }}</li>
          <li><b>Payouts that will be submitted:</b> {{ nbToSubmit - nbExcluded }}</li>
        </template>
      </ul>


      <span slot="footer" class="dialog-footer">
        <br>

        <fg-input>
          <l-checkbox v-model="createInvoice">
            <span v-tooltip.top-center="`for the payouts mentioned above plus any other payout with status 'Submitted' for ${$store.getters.periodSelected.label}`">&nbsp;Create invoice</span>
          </l-checkbox>
        </fg-input>
        <button class="btn" @click="closeModal()">Cancel</button>&nbsp;
        <button class="btn btn-success" @click="submit()" :disabled="disableSubmitButton">Confirm</button>
      </span>

    </template>

  </el-dialog>
</template>

<script>
import {Payout} from 'src/classes/datamodel.js'
export default {
  name: 'Payouts-Confirmation-Modal',
  data () {
    return {
      createInvoice: true
    }
  },
  computed: {
    modal () {
      return this.$store.getters.modal
    },
    title () {
      if (!this.modal) {
        return '-'
      }
      switch (this.modal.mode) {
        case 'Request Submission':
          return 'Requesting Payouts to be Submitted for Payment'
        case 'Submit':
          return 'Submitting Payouts for Payment'
        default:
          return 'Confirmation needed'
      } 
    },
    visible () {
      return this.$store.getters.modal.current == 'Payouts Confirmation'
    },
    nbToRequest () { // Number of payouts to request
      return this.$store.getters.payouts.filter(p => p.status == Payout._status.PENDING.value
                                                     && !p.archived).length
    },
    nbToSubmit () { // Number of payouts to submit
      return this.$store.getters.payouts.filter(p => p.status == Payout._status.SUBMISSION_REQUESTED.value
                                                     && !p.archived).length
    },
    nbExcluded () { // Number of payouts excluded (= selected via checkbox in a table on the page)
      //console.log('nbExcluded(): ', this.$store.getters.selectedObjects)
      return this.$store.getters.selectedObjects.length
    },
    nbUnsubmittable () { // because affiliate doesn't have an active card
      const result = this.$store.getters.payouts.filter(p => !p.archived && !this.affiliateHasActiveCard(p.affiliateAccountId)
                                                                         && p.status == Payout._status.PENDING.value)
      return result.length || 0
    },
    disableSubmitButton () {
      if (this.modal.mode == 'Request Submission') {
        return ( this.nbToRequest - this.nbExcluded - this.nbUnsubmittable) < 1
      }
      else {
        return (this.nbToSubmit - this.nbExcluded) < 1 && !this.createInvoice
      }
      
    },
  },
  methods: {
    closeModal () {
      this.$store.dispatch('closeModal')
    },
    affiliateHasActiveCard (affiliateAccountId) {
      const aff = this.$store.getters.affiliatesJson[affiliateAccountId]
      return aff && aff.paymentCardStatus == 'active'
    },
    async submit() {
      //console.log('savePayout: ', typeof this.payout.amount)
      let submit = (this.modal.mode == 'Submit')
      let payouts = this.$store.getters.payouts.filter(p => {
        if (p.archived) return false
        if (submit) {
          return p.status == Payout._status.SUBMISSION_REQUESTED.value
        }
        else { // submission request
          return (p.status == Payout._status.PENDING.value) && this.affiliateHasActiveCard(p.affiliateAccountId)
        }
      })
      // we remove any excluded payouts
      let selectedObjectsJson = this.$store.getters.selectedObjectsJson
      if (selectedObjectsJson && selectedObjectsJson.length > 0) {
        payouts = payouts.filter(p => !(p.id in selectedObjectsJson))
      }
      // we dispatch
      const res = await this.$store.dispatch(submit ? 'submitPayoutsForPayment' : 'requestPayoutsSubmission', payouts)
      if (res.errors) {
        if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
          this.$notify({ errorMessage: res.errors[0] })
        }
      }
      else {
        this.$notify({ successMessage: 'Submitted!'})
        // we create the invoice is asked for
        if (this.modal.mode == 'Submit' && this.createInvoice) {
          const res = await this.$store.dispatch('createPayoutsInvoice')
          if (res.errors) {
            if (!res.errors[0].toLowerCase().includes('session')) { // we don't show the error because the API service is rerouting to login page
              this.$notify({ errorMessage: res.errors[0] })
            }
          }
          else {
            this.$notify({ successMessage: 'Invoice created!\n\nYou will receive by email shortly'})
            // TODO: redirect to invoice avec 2 seconds
          }
        }
        // this.closeModal()
      }
      this.closeModal()
    }
  }
}
</script>

<style>

</style>